import events from './raws/events.json'

class Events {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    window.autoIncrementId = 1
    window.customEventsHandlers = {}
    this.handleGLobalEvents()
  }

  static handleGLobalEvents() {
    // const worker = navigator.serviceWorker
    // worker.addEventListener('message', this.handleWindowMessageEvent)
    window.addEventListener('message', this.handleWindowMessageEvent, false)
  }

  static handleWindowMessageEvent(event) {
    const eventName = event.data?.name
    const handlersIds = Object.keys(window.customEventsHandlers).filter(id =>
      id.startsWith(eventName),
    )
    handlersIds.forEach(id => {
      window.customEventsHandlers[id](event)
    })
  }

  static initKeepWorkerAlivePing() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    setInterval(() => {
      Events.dispatchEvent('keep_worker_alive', { hide_log: true })
    }, 5000)
  }

  static async sendDataRequestResolve(dataName, data, timeout = 30000) {
    const response = await new Promise(resolve => {
      Events.sendDataRequest(dataName, resolve, data)
      setTimeout(resolve, timeout, null)
    })
    return response
  }

  static sendDataRequest(dataName, onResponse, data) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return {}
    const eventName = `request:${dataName}`
    const responseId = `response:${dataName}:${window.autoIncrementId++}`
    Events.handleEvent(responseId, responseData => {
      Events.removeHandler(eventId)
      onResponse(responseData)
    })
    const eventId = Events.dispatchEvent(eventName, { ...data, responseId })
    return {
      responseId,
      unsubscribe: () => {
        Events.removeHandler(eventId)
      },
    }
  }

  static onDataResponse(responseId, handler) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return {}
    const eventHanlder = event => {
      if (event.data?.name !== responseId) return
      handler(event.data.data)
      removeListener()
    }
    const worker = navigator.serviceWorker
    const removeListener = () => {
      worker.removeEventListener('message', eventHanlder)
    }
    worker.addEventListener('message', eventHanlder)
    return removeListener
  }

  static dispatchEvent(eventName, data = {}, delay = 0) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    if (!events[eventName] && !/^(request)|(response):.+/.test(eventName)) {
      console.error(`Event ${eventName} is not registered in events list`)
      // return
    }
    // if (!data?.hide_log) console.log(`dispatch Event ${eventName}`)
    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: data,
        }),
      )
      const worker = navigator.serviceWorker
      worker.ready.then(registration => {
        try {
          registration.active.postMessage({
            name: eventName,
            data: JSON.parse(JSON.stringify(data)),
          })
        } catch (error) {
          console.log('Error to post message', eventName, error)
        }
      })
      if (self !== top) {
        window.parent?.postMessage({ name: eventName, data }, '*')
      }
      document.querySelectorAll('iframe[shareEvent]').forEach(iframe => {
        try {
          const iframeWindow = iframe.contentWindow
          iframeWindow.postMessage({ name: eventName, data }, '*')
        } catch (error) {
          console.log(
            'Error to post message on firame',
            eventName,
            error,
            iframe,
          )
        }
      })
    }, delay)
  }

  static handleEvent(eventName, callback, unicId = null) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    if (!events[eventName] && !/^(request)|(response):.+/.test(eventName)) {
      console.error(`Event ${eventName} is not registered in events list`)
      // return
    }
    const handlerKey = unicId || `${Date.now()}-${window.autoIncrementId++}`
    const id = `${eventName}----${handlerKey}`
    if (unicId) Events.removeHandler(id)

    window.customEventsHandlers[id] = event => {
      // console.log('tryHanle')
      if (event.constructor.name == 'MessageEvent') {
        if (event.data?.name !== eventName) return
        callback(event.data.data)
      } else if (event.constructor.name == 'CustomEvent') {
        callback(event.detail)
      }
    }
    document.addEventListener(eventName, window.customEventsHandlers[id])
    // const worker = navigator.serviceWorker
    // worker.addEventListener('message', window.customEventsHandlers[id])
    // window.addEventListener('message', window.customEventsHandlers[id], false)
    return id
  }

  static removeHandler(id) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    if (!id) return
    if (!window.customEventsHandlers[id]) {
      console.error(`handler ${id} not found`)
    }
    const eventName = id.replace(/(.+)----.+/, '$1')
    const worker = navigator.serviceWorker
    worker.removeEventListener('message', window.customEventsHandlers[id])
    document.removeEventListener(eventName, window.customEventsHandlers[id])
    delete window.customEventsHandlers[id]
  }
}

export { Events }
